// Preço com a promoção do cardápio (Promoções, módulo Balcão/Totem): % sobre o
// preço ou preço fixo. A mesma conta no card da grade, no popup do produto e no
// item que entra direto no carrinho (leitor de código de barras, sugestão).
// null = sem promoção que dê preço. Etiqueta da balança não passa por aqui: o
// valor dela é o impresso (decisão do dono, 30/09/2026).
export function precoPromocional(preco, promo) {
  if (!promo) return null;
  if (promo.type === "percentage") return preco * (1 - promo.value / 100);
  if (promo.type === "fixed_price") return promo.value;
  return null;
}
